import { ScreenComponent } from './../../lib/ScreenComponent';

class HelpScreen extends ScreenComponent {

	render () {
		return `
			<button class="top left" data-action="back"><span class="fas fa-arrow-left"></span></button>
			<h2 data-string="Help">Help</h2>
			<div class="row row--spaced" data-content="help">
				<p data-string="AdvanceHelp" class="row__column--12">To advance through the game, left-click or tap anywhere on the game screen or press the space key</p>
				<div class="row__column--12 row__column--tablet--6 text--left row row--spaced">
					<div class="row__column--12">
						<h3 data-string="QuickMenu">Quick Menu</h3>
					</div>
					<div class="row__column--12 row">
						<div class="row__column--2" data-content="symbols">
							<span class="fas fa-eye-slash"></span>
						</div>
						<div class="row__column--10" data-content="instruction">
							<span data-string="HideButton">Hide the dialog box</span>
						</div>
					</div>
					<div class="row__column--12 row">
						<div class="row__column--2" data-content="symbols">
							<span class="ri-chat-history-fill"></span>
						</div>
						<div class="row__column--10" data-content="instruction">
							<span data-string="DialogLogButton">Show the backlog</span>
						</div>
					</div>
					<div class="row__column--12 row">
						<div class="row__column--2" data-content="symbols">
							<span class="ri-play-circle-fill"></span>
						</div>
						<div class="row__column--10" data-content="instruction">
							<span data-string="AutoPlayButton">Enable auto play</span>
						</div>
					</div>
					<div class="row__column--12 row">
						<div class="row__column--2" data-content="symbols">
							<span class="ri-skip-forward-fill"></span>
						</div>
						<div class="row__column--10" data-content="instruction">
							<span data-string="SkipButton">Enter skip mode</span>
						</div>
					</div>
					<div class="row__column--12 row">
						<div class="row__column--2" data-content="symbols">
							<span class="ri-save-fill"></span>
						</div>
						<div class="row__column--10" data-content="instruction">
							<span data-string="SaveButton">Open the Save Screen</span>
						</div>
					</div>
					<div class="row__column--12 row">
						<div class="row__column--2" data-content="symbols">
							<span class="ri-folder-4-fill"></span>
						</div>
						<div class="row__column--10" data-content="instruction">
							<span data-string="LoadButton">Open the Load Screen</span>
						</div>
					</div>
					<div class="row__column--12 row">
					<div class="row__column--2" data-content="symbols">
						<span class="fas fa-cog"></span>
							</div>
						<div class="row__column--10" data-content="instruction">
							<span data-string="SettingsButton">Open the Settings Screen</span>
						</div>
					</div>
					<div class="row__column--12 row">
						<div class="row__column--2" data-content="symbols">
							<span class="ri-door-open-fill"></span>
						</div>
						<div class="row__column--10" data-content="instruction">
							<span data-string="QuitButton">Quit Game</span>
						</div>
					</div>
				</div>
				<div class="row__column--12 row__column--tablet--6 text--left row row--spaced">
					<div class="row__column--12">
						<h3 data-string="KeyboardShortcuts">Keyboard Shortcuts</h3>
					</div>
					<div class="row__column--12 row">
						<div class="row__column--2 row" data-content="symbols">
							<span data-content="shortcut">⇧</span>
						</div>
						<div class="row__column--10" data-content="instruction">
							<span data-string="AutoPlayButton">Enable auto play</span>
						</div>
					</div>
					<div class="row__column--12 row">
						<div class="row__column--2" data-content="symbols">
							<span data-content="shortcut">⏎</span>
						</div>
						<div class="row__column--10" data-content="instruction">
							<span data-string="NextButton">Next Dialog</span>
						</div>
					</div>
					<div class="row__column--12 row">
						<div class="row__column--2" data-content="symbols">
							<span data-content="shortcut"><span class="ri-arrow-up-line" data-content="icon"></span> / <span class="ri-arrow-down-line" data-content="icon"></span></span>
						</div>
						<div class="row__column--10" data-content="instruction">
							<span data-string="DialogLogButton">Open Backlog</span>
						</div>
					</div>
					<div class="row__column--12 row">
						<div class="row__column--2" data-content="symbols">
							<span data-content="shortcut">S</span>
						</div>
						<div class="row__column--10" data-content="instruction">
							<span data-string="SkipButton">Enter skip mode</span>
						</div>
					</div>
					<div class="row__column--12 row">
						<div class="row__column--2" data-content="symbols">
							<span data-content="shortcut">⇧ + S</span>
						</div>
						<div class="row__column--10" data-content="instruction">
							<span data-string="SaveButton">Open the Save Screen</span>
						</div>
					</div>
					<div class="row__column--12 row">
						<div class="row__column--2" data-content="symbols">
							<span data-content="shortcut">⇧ + L</span>
						</div>
						<div class="row__column--10" data-content="instruction">
							<span data-string="LoadButton">Open the Load Screen</span>
						</div>
					</div>
					<div class="row__column--12 row">
						<div class="row__column--2" data-content="symbols">
							<span data-content="shortcut">ESC</span>
						</div>
						<div class="row__column--10" data-content="instruction">
							<span data-string="HideButton">Hidden Dialog Box.</span>
						</div>
					</div>
					<div class="row__column--12 row">
						<div class="row__column--2" data-content="symbols">
							<span data-content="shortcut">⇧ + Q</span>
						</div>
						<div class="row__column--10" data-content="instruction">
							<span data-string="QuitButton">Quit Game</span>
						</div>
					</div>
				</div>
			</div>
		`;
	}
}

HelpScreen.tag = 'help-screen';



export default HelpScreen;